// src/globals.js
// export const apiUrl = 'http://127.0.0.1:8000/api/';
// export const appUrl = 'http://127.0.0.1:8000/';
// export const apiUrl = 'https://mailboxapi.malishaedu.com/api/';
// export const appUrl = 'https://mailboxapi.malishaedu.com/';
export const apiUrl = 'https://edugmails.com/api/';
export const appUrl = 'https://edugmails.com/';


